import React from 'react';
import styles from './index.module.scss';
import type { DividerLineProps } from './type';

const DividerLine: React.FC<DividerLineProps> = (props) => {
  return (
    <div className={styles.dividerLine}>
      <div className={styles.content}>{props.children}</div>
    </div>
  );
};

export default DividerLine;
